import { useQueryClient } from "@tanstack/react-query";

import { logout } from "../../core/login.core";
import LogoutIcon from "../../icons/logout.icon";

export default function LogoutComp() {
  const queryClient = useQueryClient();

  return (
    <button id="logout-button" onClick={() => logout(queryClient)}>
      <LogoutIcon className="w-6 h-6 text-her-robinEggBlue" />
    </button>
  );
}
